import Vuex, { GetterTree } from 'vuex';
import { LocationState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<LocationState, RootState> = {
  selectedCity: (state, getters) => {
    return state.city;
  },
  selectedCampus: (state, getters) => {
    return state.campus;
  },
  availableCities: (state, getters) => {
    return state.availableCities;
  },
  availableCampuses: (state, getters) => {
    return state.availableCampuses;
  },
  campusDetails: (state, getters) => {
    return state.campusDetails;
  },
};

export default getters;
